import { render, staticRenderFns } from "./bugList.vue?vue&type=template&id=356d2de6&scoped=true&"
import script from "./bugList.vue?vue&type=script&lang=js&"
export * from "./bugList.vue?vue&type=script&lang=js&"
import style0 from "./bugList.vue?vue&type=style&index=0&id=356d2de6&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.10.2/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "356d2de6",
  null
  
)

export default component.exports